import jQuery from 'jquery';
import clamp from 'clamp-js';

(function ($) {
    const $glossarySection = $('.glossary-list-section');

    const clampDescription = () => {
        $('.link-description').each(function () {
            const $description = $(this);
            const descriptionEl = $description[0];
            const descriptionHeight = $description.innerHeight();
            const $icon = $description.next('.link-icon');

            if (descriptionHeight > 52) {
                $icon.removeClass('hide');
                $description.addClass('clamped');
                clamp(descriptionEl, { clamp: 2 });
            } else {
                $icon.addClass('hide');
            }
        });
    };

    const debounce = (func, delay) => {
        let timeout;
        return function (...args) {
            clearTimeout(timeout);
            timeout = setTimeout(() => func.apply(this, args), delay);
        };
    };

    const handleLinkClick = function () {
        const $link = $(this);
        const $icon = $link.find('.link-icon');
        const $description = $link.find('.clamped');

        $icon.toggleClass('close');
        $description.toggleClass('expanded');

        if ($description.hasClass('expanded')) {
            $description.removeAttr('style');
        } else {
            clamp($description[0], { clamp: 2 });
        }
    };

    if ($glossarySection.length) {
        $('.link-url').on('click', handleLinkClick);
        clampDescription();
        $(window).on('resize', debounce(clampDescription, 200)); // Adjust delay as needed
    }
})(jQuery);
